import { IS_PRODUCTION } from "@constants/env";
import { useAppStore } from "@hooks/useAppStore";

const AnalyticsDestinationType = {
	Mixpanel: "mixpanel",
	Segment: "segment",
} as const;
type AnalyticsDestinationTypeKeys =
	(typeof AnalyticsDestinationType)[keyof typeof AnalyticsDestinationType];

// Get all analytics destinations from the local state, adding the legacy mixpanel destination if it exists and isn't already in the array of analyticsDestinations for
// backwards compatibility
const getAnalyticsDestinations = () => {
	if (!IS_PRODUCTION) {
		const stagingMixpanelToken = process.env.EXPO_PUBLIC_MIXPANEL_TOKEN_STAGING;
		if (!stagingMixpanelToken) {
			return [];
		}
		return [
			{
				type: AnalyticsDestinationType.Mixpanel,
				apiKey: stagingMixpanelToken,
			},
		];
	}

	// Get the analytics destinations from the local state
	const analyticsDestinations =
		useAppStore.getState().app?.analytics?.analyticsDestinations || [];

	// If the mixpanel destination exists and isn't already in the array of analyticsDestinations, add it for backwards compatibility
	if (
		useAppStore.getState().app?.analytics?.mixpanel &&
		!analyticsDestinations.find(
			(destination) =>
				destination.apiKey ===
				useAppStore.getState().app?.analytics?.mixpanel.id,
		)
	) {
		analyticsDestinations.push({
			type: AnalyticsDestinationType.Mixpanel,
			apiKey: useAppStore.getState().app?.analytics?.mixpanel.id,
		});
	}

	return analyticsDestinations;
};

export {
	getAnalyticsDestinations,
	AnalyticsDestinationType,
	type AnalyticsDestinationTypeKeys,
};
